import { twMerge } from 'tailwind-merge'

interface IAnswerButtonProps {
  label: string
  isSelected?: boolean
  onClick: () => void
  className?: string
  disabled?: boolean
}

const AnswerButton = ({ label, isSelected = false, onClick, className, disabled = false }: IAnswerButtonProps) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={twMerge(
        'w-full py-4 px-6 rounded-2xl font-medium text-lg transition-all duration-200',
        'border-2 shadow-sm hover:shadow-md',
        'active:scale-95 focus:outline-none focus:ring-4 focus:ring-amber-200',
        isSelected
          ? 'bg-gradient-to-r from-amber-400 to-yellow-500 text-white border-amber-500 shadow-lg scale-[1.02]'
          : 'bg-white text-gray-700 border-gray-200 hover:border-amber-300 hover:bg-amber-50',
        disabled && 'opacity-50 cursor-not-allowed',
        className
      )}
    >
      {label}
    </button>
  )
}

export default AnswerButton
